import React, { useContext, useEffect, useRef, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import TransactionTable from "./TransactionTable";
import Pagination from "../Pagination";
import dayjs from "dayjs";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import AnimatedComponent from "components/reusable/AnimatedComponent";
import OSearch from "components/reusable/OSearch";
import helpers from "utils/helpers";
import { BiSolidFileExport } from "react-icons/bi";
import { AnimatePresence, motion } from 'framer-motion';
const tabs = [
  { name: "Booking", value: "wallet" },
  { name: "Tip", value: "tip" },
  { name: "Refund", value: "refund" },
];
function Transaction() {
  const [activeTab, setActiveTab] = useState("wallet");
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === "transaction_manager") ?? {};
  const [artistVerification, setArtistVerification] = useState([]);
  const [totalCommission, setCommission] = useState(0)
  const childRef = useRef();
  const [searchTer, setSearchTer] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [paginationsObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [filtersData, setFiltersData] = useState({
    category: "foreignTourist",
    searchkey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const dynamicPage = (e) => {
    const newPage = e?.selected + 1;
    setPage(newPage);
  };
  const allTransaction = async (userType = "listing") => {
    try {
      const { startDate, endDate, searchkey } = filtersData;
      const payload = {
        page,
        pageSize,
        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: helpers.normalizeSpaces(searchkey) || null,
        sortBy: sort.sortBy,
        sortType: sort.sortType,
        timezone: new Date().getTimezoneOffset(),
        type:activeTab
      };

      const path = apiPath.alltransactionList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results?.docs;
      const resultStatus = result?.data?.success;
      setCommission(result?.data?.results?.totalCommission)
      if (userType == "export") {
        helpers.downloadFile(result?.data?.results?.csvFilePath);
      } else {
        setArtistVerification(response);
      }
      setPaginationObj({
        ...paginationsObj,
        page: resultStatus ? result?.data?.results.page : null,
        pageCount: resultStatus ? result?.data?.results.totalPages : null,
        perPageItem: resultStatus ? response?.length : null,
        totalItems: resultStatus ? result?.data?.results.totalDocs : null,
      });
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allTransaction();
  }, [filtersData, page, sort, pageSize,activeTab]);

  const handleReset = () => {
    setSearchTer("")
    setFiltersData({
      category: "",
      isReset: true,
      startDate: "",
      endDate: "",
      isFilter: false,
    });
    setPage(1);
    setPageSize(10);
    childRef?.current?.onClose();
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFiltersData({
      ...filtersData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFiltersData({
        ...filtersData,
        isReset: false,
        searchkey: searchTer ? searchTer.trim() : "",
        isFilter: !!searchTer,
      });
      setPage(1);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTer]);

  return (
    <div>
      <div className="bg-[#F9F9F9] dark:bg-slate-900 p-4">
        <div className="">


          <AnimatePresence mode="wait">
            <motion.div
              key={"empty"}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div className=" py-3 mb-3">
                <div className="flex flex-wrap gap-3">
                  {tabs?.map((tab) => (

                    <motion.div
                      className="rounded-xl shadow-md border "
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, ease: "easeOut" }}
                      whileHover={{ scale: 1.05, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)" }}
                      whileTap={{ scale: 0.95 }}
                      key={tab?.value}
                    >
                      <button

                        onClick={() => {
                          setPage(1);
                          setFiltersData({
                            ...filtersData,
                            startDate: "",
                            endDate: "",
                          });
                          setSearchTer("");
                          handleReset()
                          setActiveTab(tab?.value);
                        }}
                        className={`relative px-5 py-2 w-[150px] rounded-xl text-sm transition-all duration-200 ${activeTab === tab?.value
                          ? "bg-black text-white shadow-md"
                          : "bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
                          }`}
                      >
                        {tab?.name}
                        {activeTab === tab?.value && (
                          <motion.div layoutId="tab-indicator" />
                        )}
                      </button>
                    </motion.div>
                  ))}

                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="bg-white border border-[#E9EDF9] rounded-lg dark:bg-gray-800 dark:mt-4">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center">
                <div className="relative flex items-center mb-3">
                  <OSearch
                    placeholders={t("SEARCH_BY_TRANSACTION")}
                    onChange={(e) => {
                      setSearchTer(e?.target?.value);
                    }}
                    className="w-[300px] h-[38px] rounded-lg"
                    ref={childRef}
                  />


                </div>
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center mb-2 2xl:mb-0">
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filtersData?.isReset}
                    setIsReset={setFiltersData}
                  />

                  <button
                    type="button"
                    onClick={handleReset}
                    title={t("O_RESET")}
                    className="bg-gradientTo text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
                  >
                    {t("O_RESET")}
                  </button>

                </div>
                <div>
                  {artistVerification?.length > 0 && (
                    <button type="button" title={t("EXPORT_CSV")} className="bg-gradientTo text-sm flex gap-2 px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto " onClick={() => allTransaction("export")} >
                      <BiSolidFileExport size={18} />
                      {t("EXPORT_CSV")}
                    </button>
                  )}
                </div>
               
              </div>
            </form>
            <AnimatedComponent>
              <TransactionTable
                artistVerification={artistVerification}
                allTransection={allTransaction}
                page={page}
                setSort={setSort}
                sort={sort}
                manager={manager}
                pageSize={pageSize}
                activeTab={activeTab}
              />
            </AnimatedComponent>
            {paginationsObj?.totalItems ? <Pagination handlePageClick={dynamicPage} options={paginationsObj} page={page} /> : null}
          </div>
        </div>
      </div>
      <></>
    </div>
  );
}

export default Transaction;
